import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';

export default function InputToggler(props) {
  const { filter, onClickUserInput, disableUserInputToggler } = props;
  const userInput = filter.get('userInput');
  const userInputOpen = filter.get('userInputOpen');

  return userInput === 'TEXT' ? (
    <ButtonWithIcon
      data-e2e="filter-by-value"
      type="link"
      sprite={userInputOpen ? 'ChevronUp' : 'ChevronDown'}
      iconRight
      linkIconSize="xs"
      onClick={onClickUserInput}
      disabled={disableUserInputToggler}
      aria-expanded={userInputOpen}
      className="e2e-filter-by-value">
      Filter by value
    </ButtonWithIcon>
  ) : (
    <div className="bar-chart-filter-user-input-shadow" />
  );
}

InputToggler.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  onClickUserInput: PropTypes.func.isRequired,
  disableUserInputToggler: PropTypes.bool.isRequired,
};
